module.exports = __webpack_public_path__ + "static/img/13.a27d97aa.jpg";